<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Modal from '$components/elements/Modal.svelte';
  import { globalError, globalErrorId } from '$lib/stores';

  const onClose = () => {
    globalError.set(null);
    globalErrorId.set(null);
  };
</script>

<Modal showModal={$globalError !== null} {onClose} overlayOnMobile>
  <div class="error">
    {@html $globalError}
    {#if $globalErrorId !== null}
      <br />
      <small><i>Error ID: {$globalErrorId}</i></small>
    {/if}
    <Button on:click={onClose}>Zavřít</Button>
  </div>
</Modal>

<style lang="scss">
  .error {
    padding: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    gap: 24px;
    flex-direction: column;
    z-index: 10000;
  }
</style>
